import { Component, OnInit } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import * as _ from "lodash";
import { Router } from "@angular/router";
import { TSFuntionService } from "../../services/ts-funtion.service";

import { BsModalRef } from "ngx-bootstrap/modal";

@Component({
  selector: "app-ro-service",
  templateUrl: "./ro-service.component.html",
})
export class ROServiceComponent implements OnInit {
  constructor(
    private http: HttpClient,
    private router: Router,
    private System: TSFuntionService
  ) {}
  modalRef: BsModalRef;

  public settings = {};

  Legend = true;
  _RequestType = [];
  _Status = [];
  _Company = [];
  _Requester = [];
  IsSearchOpen = true;

  FilterGrid = {
    sSearch: "",
    nReqType: [],
    dSubmittedDate: [],
    sRequester: [],
    nStatusID: [],
    dExpectedCompleteDate: [],
    sCompanyCode: [],
  };

  OptionGrid = {
    nCurrentPage: 1,
    maxSize: 7,
    nPageSize: 10,
    nTotalItem: 0,
    ArrPageSize: [
      { sValue: 10 },
      { sValue: 20 },
      { sValue: 50 },
      { sValue: 100 },
    ],
  };
  IsHeaderSort = "";
  SortDirection = "";
  SortICO = "fas fa-sort";
  IcoSort = "fas fa-sort";
  IcoSortDesc = "fas fa-sort-down";
  IcoSortAsc = "fas fa-sort-up";
  sDetailData = "";
  _ArrData = [];
  _ArrDataBind = [];
  arrGL: any;
  Columns = [
    { ColumnName: "", SortField: "", Width: "4%" },
    { ColumnName: "No.", SortField: "", Width: "3%" },
    { ColumnName: "RO Req. No.", SortField: "sRequestCode", Width: "10%" },
    { ColumnName: "Req. No.", SortField: "sRequestCode2", Width: "10%" },
    { ColumnName: "Type", SortField: "sReqType", Width: "16%" },
    { ColumnName: "Company", SortField: "sCompName", Width: "22%" },
    { ColumnName: "Requester Name", SortField: "sRequesterName", Width: "8%" },
    { ColumnName: "Submitted Date", SortField: "dUpdateDate", Width: "13%" },
    { ColumnName: "Status", SortField: "sStatusName", Width: "13%" },
  ];

  IsROService = false;
  IsROServiceSSC = false;
  IsHiddenCreate = true;
  ngOnInit() {
    this.SetDataOnPageLoad();
    this.settings = {
      singleSelection: false,
      idField: "sValue",
      textField: "sText",
      enableCheckAll: true,
      selectAllText: "Select All",
      unSelectAllText: "Unselect All",
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      maxHeight: 197,
      itemsShowLimit: 1,
      searchPlaceholderText: "Search",
      noDataAvailablePlaceholderText: "No Data",
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false,
    };
    const ua = this.System.GetUserStorage();
    if (ua) {
      if (ua.IsROService) {
        this.IsROService = true;
      }
      if (ua.IsROService && ua.nRole === 2) {
        this.IsROServiceSSC = true;
        this.FilterGrid.sCompanyCode = [];
        ua.lstCompCode.forEach(f =>
          this.FilterGrid.sCompanyCode.push({sValue: f.sCompCode, sText: f.sCompName})
        );
      }
      if(ua.nRole === 5){
        this.IsHiddenCreate = false;
      }
      this.GetData();
    }
  }

  SetDataOnPageLoad() {
    this.http
      .get<any>(this.System.SiteName + "api/ROService/_GetRequestType")
      .subscribe((res) => {
        this._RequestType = res;
      });
    this.http
      .get<any>(this.System.SiteName + "api/ROService/_GetStatus")
      .subscribe((res) => {
        this._Status = res;
      });
    this.http
      .get<any>(this.System.SiteName + "api/ROService/_Company")
      .subscribe((res) => {
        this._Company = res;
      });
    this.http
      .get<any>(this.System.SiteName + "api/ROService/_GetRequester")
      .subscribe((res) => {
        this._Requester = res;
      });
  }

  SortHeaderClick(ColumnName: string, SortField: string) {
    if (ColumnName) {
      if (ColumnName === this.IsHeaderSort) {
        this.SortDirection = this.SortDirection === "asc" ? "desc" : "asc";
        this.SortICO =
          this.SortDirection === "asc" ? this.IcoSortAsc : this.IcoSortDesc;
      } else {
        this.SortICO = this.IcoSortAsc;
        this.SortDirection = "asc";
      }
      this.IsHeaderSort = ColumnName;
      this._ArrData = _.orderBy(
        this._ArrData,
        [SortField],
        [this.SortDirection]
      );
      this.BindDataTable();
    }
  }

  PageSizeChange() {
    setTimeout(() => {
      this.OptionGrid.nCurrentPage = 1;
      this.BindDataTable();
    });
  }

  PageChanged(event: any) {
    this.OptionGrid.nCurrentPage = event.page;
    this.BindDataTable();
  }

  GetData() {
    const _this = this;
    this.OptionGrid.nCurrentPage = 1;
    this.System.BlockUI();
    const _sReqType: string =
      this.FilterGrid.nReqType.length > 0
        ? this.FilterGrid.nReqType.map((e) => e.sValue).join(",")
        : "";
    const _sStatus: string =
      this.FilterGrid.nStatusID.length > 0
        ? this.FilterGrid.nStatusID.map((e) => e.sValue).join(",")
        : "";
    const _sCompanyCode: string =
      this.FilterGrid.sCompanyCode.length > 0
        ? this.FilterGrid.sCompanyCode.map((e) => e.sValue).join(",")
        : "";
    const _sRequester: string =
      this.FilterGrid.sRequester.length > 0
        ? this.FilterGrid.sRequester.map((e) => e.sValue).join(",")
        : "";

    if (this.FilterGrid.dSubmittedDate == null) {
      this.FilterGrid.dSubmittedDate = [];
    }
    if (this.FilterGrid.dExpectedCompleteDate == null) {
      this.FilterGrid.dExpectedCompleteDate = [];
    }

    const headers = new HttpHeaders({
      "Content-Type": "application/json",
    });
    const data = {
      sSearch: this.FilterGrid.sSearch,
      sReqType: _sReqType,
      dSubmittedDate: this.FilterGrid.dSubmittedDate,
      sRequester: _sRequester,
      sStatus: _sStatus,
      dExpectedCompleteDate: this.FilterGrid.dExpectedCompleteDate,
      sCompanyCode: _sCompanyCode,
    };

    const ITEM = JSON.stringify(data);

    this.http
      .post<any>(this.System.SiteName + "api/ROService/ListData", ITEM, {
        headers,
        responseType: "json",
      })
      .subscribe((res) => {
        if (res) {
          this._ArrData = res;
        } else {
          this._ArrData = [];
        }
        this.BindDataTable();
      });
  }

  BindDataTable() {
    const user = this.System.GetUserStorage();
    const nRole = user.nRole;
    const status = this.Getstatus(nRole);
    this.OptionGrid.nTotalItem = this._ArrData.length;

    const nPageSize = this.System.ParseIntToZero(this.OptionGrid.nPageSize);
    const nStartIndex_Take = (this.OptionGrid.nCurrentPage - 1) * nPageSize;
    const nEndIndex_Take = nPageSize;
    this._ArrDataBind = [];
    this._ArrData.forEach((val) =>
      this._ArrDataBind.push(Object.assign({}, val))
    );
    this._ArrDataBind = this._ArrDataBind.splice(
      nStartIndex_Take,
      nEndIndex_Take
    );
    const nStartItemPage = nStartIndex_Take + 1;
    const nLastItemPage = nStartIndex_Take + this._ArrDataBind.length;
    this.sDetailData =
      "Showing " +
      nStartItemPage +
      " to " +
      nLastItemPage +
      " of " +
      this._ArrData.length +
      " Rows";
    this.System.UnBlockUI();
  }

  async EditData(_Item) {
    const ua = this.System.GetUserStorage();
    let sUrl = "/ro-service-request";
    if (ua.IsROService) {
      sUrl = this.GetpathTReq(_Item.nReqType);
    }
    const ID = await this.System.Encrypt(_Item.sRequestID);
    await this.router.navigate([sUrl], { queryParams: { ros: ID } });
  }

  async ViewData(_Item) {
    const ua = this.System.GetUserStorage();
    const nRole = ua.nRole;
    const nStatus = _Item.nStatusID;
    const nReqType = _Item.nReqType;
    const IsManual = _Item.IsManual;
    
    let sUrl = '';

    switch (nRole) {
      case 1: // Admin
        sUrl = '/approve';
        break;
      case 2: // SSC
        switch (nStatus) {
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
          case 7:
          case 10:
            sUrl = '/approve';
            break;
          case 6: // Wait Doc Receiving
            sUrl = '/admin-receivingdoc';
            break;
          case 8: // Wait Adjust Invoice
            sUrl = '/admin-adjust';
            break;
          case 9: // Wait Export to SAP
          case 15: // Wait Export to SAP
            sUrl = '/exportto-sap';
            if (nReqType === 50 || nReqType === 70 || nReqType === 71 || nReqType === 80 || nReqType === 90 || IsManual) {
              sUrl = '/manual-updatefi'
            }
            break;
          case 11: // Waiting Payment
            sUrl = '/admin-payment';
            break;
          case 12: // Waiting Supporting Document
            sUrl = '/admin-supportdoc';
            break;
          case 13: // Complete
            sUrl = '/approve';
            break;
        }
        break;
      case 3: // Approve1
      case 4: // Approve2
        sUrl = '/approve';
        break;
      case 5: // Request
      case 7: //ROService
        switch (nStatus) {
          case 1:
          case 3:
          case 5:
          case 7:
          case 10:
            sUrl = this.GetpathTReq(_Item.nReqType);
            break;
          case 2:
          case 4:
          case 6:
          case 8:
          case 9:
          case 11:
          case 12:
          case 13:
          case 15:
            sUrl = '/approve';
            break;
        }
        break;
      case 6: // SVM
        sUrl = '/approve';
        break;
    }

    const ID = await this.System.Encrypt(_Item.sRequestID);
    await this.router.navigate([sUrl], { queryParams: { str: ID } });
  }

  GetpathTReq(nReqType: number) {
    let sUrl = "";
    switch (nReqType) {
      case 10:
      case 11:
        sUrl = "/paytovendor";
        break;
      case 12:
        sUrl = "/paytoemp";
        break;
      case 20:
        sUrl = "/advancerequest";
        break;
      case 30:
        sUrl = "/clearadvance";
        break;
      case 40:
        sUrl = "/pettycash";
        break;
      case 50:
        sUrl = "/other";
        break;
      case 60:
      case 61:
        sUrl = "/cntype";
        break;
      case 70:
      case 71:
        sUrl = "/billingtocash";
        break;
      case 80:
        sUrl = "/journalvoucher";
        break;
      case 90:
        sUrl = '/receiptvoucher';
        break;
    }
    return sUrl;
  }

  Getstatus(nRole: number) {
    const status = [];
    switch (nRole) {
      case 1:
        status.push(1, 2, 3);
        break;
      case 2:
        status.push(2);
        break;
    }
    return status;
  }

  GetColorText(_Item: any) {
    let sColor = "";
    switch (_Item.nStatusID) {
      case 4:
        sColor = "_text_red_paster";
        break;
      case 5:
      case 6:
        sColor = "_text_green_paster";
        break;
    }
    return sColor;
  }

  SearchShow() {
    this.IsSearchOpen = !this.IsSearchOpen;
  }

  ClearData() {
    this.FilterGrid.sSearch = "";
    this.FilterGrid.nReqType = [];
    this.FilterGrid.nStatusID = [];
    this.FilterGrid.dSubmittedDate = [];
    this.FilterGrid.dExpectedCompleteDate = [];
    if (this.IsROServiceSSC) {
      const ua = this.System.GetUserStorage();
      this.FilterGrid.sCompanyCode = [];
      ua.lstCompCode.forEach(f =>
        this.FilterGrid.sCompanyCode.push({sValue: f.sCompCode, sText: f.sCompName})
      );
    }
    this.GetData();
  }

  async Add() {
    await this.router.navigate(["/ro-service-request"]);
  }
}
